import FormOrdenTrabajo from "../componentes/FormOrdenTrabajo.vue";
import ListaOrdenTrabajo from "../componentes/ListaOrdenTrabajo.vue";
import ConsultaOrdenTrabajo from "../componentes/ConsultaOrdenTrabajo.vue";
import InformeAnual from "../componentes/InformeAnual.vue";
import ListaOrdenFinal from "../componentes/ListaOrdenFinal.vue";
import ListaFichajes from "../componentes/ListaFichajes.vue";

import CalendarioOrden from "../componentes/CalendarioOrden.vue"

import SeguimientoOrden from "../componentes/SeguimientoOrden.vue";

const routes = [
    ...route("/guardar-orden", FormOrdenTrabajo, {
        Auth: true,
        //req_admin: true,
    }),
    ...route("/lista-ordenes", ListaOrdenTrabajo, {
        Auth: true,
        //req_admin: true
    }),
    ...route("/lista-fichajes-ordenes", ListaFichajes, {
        Auth: true,
        //req_admin: true
    }),
    ...route("/consulta-ordenes", ConsultaOrdenTrabajo, {
        Auth: true,
        //req_admin: true
    }),
    ...route("/lista-ordenes-final", ListaOrdenFinal, {
        Auth: true,
        //req_admin: true
    }),
    ...route("/informe-anual", InformeAnual, {
        Auth: true,
        //req_admin: true
    }),
    ...route("/seguimiento-orden-trabajo", SeguimientoOrden, {
        Auth: true,
    }),
    ...route("/calendario-orden", CalendarioOrden, {
        Auth: true,
    }),
];

function route(path, component = Default, meta = {}) {
    return [{
        path,
        component,
        meta,
    }, ];
}

export default routes;